<main class="msg-page">
  <section class="msg-page__card" aria-live="polite">
    @switch (phase) {
      @case ('loading') {
        <mat-spinner class="msg-page__spinner" diameter="28"></mat-spinner>
      }

      @case ('done') {
        <div class="msg-page__badge"><mat-icon>task_alt</mat-icon></div>
        <h1 class="msg-page__title">{{strings['unsub_done_title']}}</h1>
        <p class="msg-page__body">{{ getString('unsub_done_text', name) }}</p>
      }

      @case ('invalid') {
        <div class="msg-page__badge msg-page__badge--error"><mat-icon>link_off</mat-icon></div>
        <h1 class="msg-page__title">{{strings['unsub_invalid_title']}}</h1>
        <p class="msg-page__body">{{strings['unsub_invalid_text']}}</p>
      }

      @default {
        <div class="msg-page__badge msg-page__badge--warn"><mat-icon>unsubscribe</mat-icon></div>
        <h1 class="msg-page__title">{{strings['unsub_title']}}</h1>
        <p class="msg-page__body">{{ getString('unsub_text', name) }}</p>
        @if (phase === 'error') {
          <p class="msg-page__body msg-page__body--error" role="alert">{{strings['error_unknown']}}</p>
        }
        <div class="msg-page__actions">
          <button mat-flat-button color="primary" type="button" [disabled]="phase === 'working'" (click)="unsubscribe()">
            {{strings['unsub_button']}}
          </button>
        </div>
        @if (phase === 'working') {
          <mat-spinner class="msg-page__spinner" diameter="28"></mat-spinner>
        }
      }
    }
  </section>

  <p class="msg-page__foot">Measure Map Online</p>
</main>
